export const    DINING = 'DINING';
export const    DINING_SUCCESS = 'DINING_SUCCESS';
export const    DINING_ERROR = 'DINING_ERROR';

export const DINING_TAGS = 'DINING_TAGS';
export const DINING_TAGS_SUCCESS = 'DINING_TAGS_SUCCESS';
export const DINING_TAGS_ERROR = 'DINING_TAGS_ERROR';


export const DINING_FILTERS = 'DINING_FILTERS';
export const DINING_FILTERS_SUCCESS = 'DINING_FILTERS_SUCCESS';
export const DINING_FILTERS_ERROR = 'DINING_FILTERS_ERROR';

export const    ADD_DINING = 'ADD_DINING';
export const    ADD_DINING_SUCCESS = 'ADD_DINING_SUCCESS';
export const    ADD_DINING_ERROR = 'ADD_DINING_ERROR';

export const    UPDATE_DINING = 'UPDATE_DINING';
export const    UPDATE_DINING_SUCCESS = 'UPDATE_DINING_SUCCESS';
export const    UPDATE_DINING_ERROR = 'UPDATE_DINING_ERROR';

export const DELETE_DINING = 'DELETE_DINING';
export const DELETE_DINING_SUCCESS= 'DELETE_DINING_SUCCESS';
export const DELETE_DINING_ERROR ='DELETE_DINING_ERROR';

export const BATCH_DELETE_DINING_SUCCESS= 'BATCH_DELETE_DINING_SUCCESS';
export const DELETE_ALL_DINING_SUCCESS= 'DELETE_ALL_DINING_SUCCESS';


export const    ADD_DINING_IMAGE = 'ADD_DINING_IMAGE';
export const    ADD_DINING_IMAGE_SUCCESS = 'ADD_DINING_IMAGE_SUCCESS';
export const    ADD_DINING_IMAGE_ERROR = 'ADD_DINING_IMAGE_ERROR';

export const    GET_DINING_IMAGES = 'GET_DINING_IMAGES';
export const    GET_DINING_IMAGES_SUCCESS = 'GET_DINING_IMAGES_SUCCESS';
export const    GET_DINING_IMAGES_ERROR = 'GET_DINING_IMAGES_ERROR';

export const    GET_WEEK_DININGS = 'GET_WEEK_DININGS';
export const    GET_WEEK_DININGS_SUCCESS = 'GET_WEEK_DININGS_SUCCESS';
export const    GET_WEEK_DININGS_ERROR = 'GET_WEEK_DININGS_ERROR';